/* AQ — Filtres au téléphone, v1.0, 2026-09-14.

   Demande de Félix : « quand j'ouvre un filtre sur mobile ça ne fonctionne
   pas ». Relevé en direct sur la barre de filtres : à l'ouverture d'un
   panneau, le moteur pose le curseur dans le champ de recherche du panneau.
   Au bureau c'est confortable. Au téléphone, le clavier du système monte
   aussitôt et couvre le panneau, qui est une feuille ancrée au bas de
   l'écran : il ne reste visible que le champ et la barre du clavier, la liste
   des choix passe dessous. C'est ce que montrait la capture, les chevrons et
   le crochet étant la barre d'accessoires du clavier, pas un élément du site.

   Correctif : au téléphone, le champ de recherche du panneau est mis en
   lecture seule le temps de l'ouverture. Un champ en lecture seule peut
   recevoir le curseur sans faire monter le clavier, donc le moteur garde son
   geste et la liste reste entière à l'écran. Dès que la personne touche le
   champ elle-même, la lecture seule est levée et le clavier monte, comme
   attendu. À la fermeture, tout est remis en place.

   Feuille de comportement additive, chargée par snippets/aq-fonts.liquid.
   Inerte sur une page sans barre de filtres et au-dessus de 750 px. */
(function () {
  'use strict';

  var TELEPHONE = '(max-width: 749.98px)';

  function auTelephone() {
    return window.matchMedia && window.matchMedia(TELEPHONE).matches;
  }

  function liberer(champ) {
    if (!champ || !champ.hasAttribute('data-aq-cn7-verrou')) return;
    champ.removeAttribute('data-aq-cn7-verrou');
    champ.readOnly = false;
  }

  function verrouiller(champ) {
    if (!champ || champ.hasAttribute('data-aq-cn7-verrou')) return;
    champ.setAttribute('data-aq-cn7-verrou', '');
    champ.readOnly = true;
  }

  /* Le premier contact de la personne avec le champ lève le verrou et lui
     rend le curseur, donc le clavier monte au geste voulu. */
  function surContact(e) {
    var champ = e.target;
    if (!champ || !champ.hasAttribute || !champ.hasAttribute('data-aq-cn7-verrou')) return;
    liberer(champ);
    try { champ.focus(); } catch (err) {}
  }

  document.addEventListener('pointerdown', surContact, true);
  document.addEventListener('touchstart', surContact, true);

  document.addEventListener('click', function (e) {
    var cible = e.target;
    if (!cible || !cible.closest) return;

    var pastille = cible.closest('.aqcn7__pill[data-aqcn7-toggle]');
    if (pastille) {
      if (!auTelephone()) return;
      var panneau = document.getElementById(pastille.getAttribute('data-aqcn7-toggle'));
      if (!panneau) return;
      var champ = panneau.querySelector('.aqcn7__search input');
      if (!champ) return;
      /* posé avant que le moteur n'ouvre le panneau et ne pose le curseur */
      verrouiller(champ);
      return;
    }

    /* un clic hors d'un panneau le referme : on rend leurs champs */
    if (!cible.closest('.aqcn7__panel')) {
      var champs = document.querySelectorAll('.aqcn7__panel [data-aq-cn7-verrou]');
      for (var i = 0; i < champs.length; i++) liberer(champs[i]);
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var champs = document.querySelectorAll('.aqcn7__panel [data-aq-cn7-verrou]');
    for (var i = 0; i < champs.length; i++) liberer(champs[i]);
  });
})();
